import { useState, useEffect, SetStateAction, useRef } from "react";
import Top from "../components/templates/top";
import Button from "../components/atoms/button";
import Link from "../components/atoms/link";
import Paragraph from "../components/atoms/paragraph";
import { RadioToggleButton } from "../components/molecules/radio-toggle-buttons";
import { useNavigate } from "react-router-dom";
import {
  addConfirmData,
  credentialData,
  principalAddress,
} from "../redux/slices/confirmDataReducer";
import { useDispatch } from "react-redux";
import { store } from "../redux/store";
import PersonalDataService from "../services/personalData.service";
import { useApi } from "../hooks/useApi";
import { IDataINE } from "../interfaces/api/IPersonalData";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";
import { DataINEuseCase } from "../../application/use-cases/dataINE.usecase";

const AddressCondition = () => {
  const state = store.getState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [btnColor, setBtnColor] = useState("button-disabled");
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [enabledButton, setEnabledButton] = useState(true);
  const [radioToggleValue, setRadioToggleValue] = useState("");
  const [addressIne, setAddressIne] = useState(true);
  const [, setSec] = useState<number>(0);
  const [toggle] = useState<boolean>(false);
  const ref = useRef<NodeJS.Timeout | null>(null);
  const [modalShow, setModalShow] = useState(false);
  const [dataGetDataINE, setDataGetDataINE] = useState<IDataINE | null>();
  const getDataINEService = new PersonalDataService();
  const usecasegetDataINE = new DataINEuseCase(getDataINEService);

  const continueProcess = async () => {
    const response = await usecasegetDataINE.getDataINE(state.client.clientPersist.uuid);
    if (response.error !== null) {
      setModalShow(true);
    } else {
      setDataGetDataINE(response.data)
      let dateString = response.data?.dateBirth;
      var dateObj = dateString?.replace(/(\d{4})-(\d{2})-(\d{2})/, "$1/$2/$3")

      dispatch(
        addConfirmData({
          curp: response.data?.curp,
          dateBirth: dateObj,
          email: state.client.dataPersist.email,
          gender: response.data?.gender,
          lastName1: response.data?.lastName1,
          lastName2: response.data?.lastName2,
          name1: response.data?.name1,
          name2: response.data?.name2,
          phone: state.client.dataPersist.phone,
          placeBirth: "MX",
          nationality: "MX"
        }),
      );
      dispatch(
        principalAddress({
          colony: response.data?.addresses[0]?.town,
          country: "MX",
          zipCode: response.data?.addresses[0]?.zipCode,
          street: response.data?.addresses[0]?.street,
          streetNumber: "",
          city: response.data?.addresses[0]?.city
        }),
      );

      dispatch(
        credentialData({
          cic: response.data?.credentialData?.cic,
          dateOfExpiration: response.data?.credentialData.dateOfExpiration,
          dateOfIssue: response.data?.credentialData.emissionNumber,
          electorKey: response.data?.credentialData.electorKey,
          ocr: response.data?.credentialData.ocr,
          registerYear: response.data?.credentialData.registerYear
        }),
      );

      let routerNext = "/ProofAddressCondition";
      if (radioToggleValue == "Si coincide") {
        routerNext = "/DataConfirmation";
      }
      navigate(routerNext);
    }
  };

  const radioChangeHandler = (e: { target: { value: SetStateAction<string> } }) => {
    setRadioToggleValue(e.target.value);
    setEnabledButton(false);
    setBtnColor("button-enabled");
  };

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/AddressCondition",
        step: "CONTINUE_AFTER",
        data: {}, // Agregar data del formulario
      },
    });
  };

  const functionProcessModal = () => {
    setModalShow(false);
    window.location.reload()
  };

  useEffect(() => {
    if (!addressIne) {
      setRadioToggleValue("No, capturar comprobante");
      setEnabledButton(false);
      setBtnColor("button-enabled");
    }
  }, [addressIne]);

  useEffect(() => {
    ref.current = setInterval(() => {
      if (toggle) setSec((state) => state + 1);
      var condition = localStorage.getItem("condition") === "true" ? true : false;

      if (!condition) {
        navigate("/CaptureINE");
      } else {
      }
    });

    return () => {
      if (ref.current) clearInterval(ref.current);
    };
  }, [toggle]);

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={"Apertura de cuenta"}
          subTitle={"Domicilio"}
          displayProgressBar={""}
          displayLeftImageTitle={"d-none"}
          classTitleImage={""}
          classHeader={"mt-2 mb-3"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"40%"}
          comeFrom={"/AddressCondition"}
          onClickGoBackIcon={undefined}
        />
        <div className="p-3">
          <Paragraph
            text={"¿El domicilio que aparece en tu INE coincide con tu domicilio actual?"}
            className={""}
            styleParagraph={undefined}
          />
          <div className="mb-4_3">
            <RadioToggleButton
              id={"Si coincide"}
              text={"Si coincide"}
              value={"Si coincide"}
              type={"radio"}
              name={"Si coincide"}
              onChange={radioChangeHandler}
              isSelected={radioToggleValue == "Si coincide"}
              className="radioToggleButton me-3"
              icon={undefined}
              displayImg="d-none"
              disabledInput={!addressIne}
              divStyle={undefined}
              labelStyle={addressIne ? undefined : { color: "#A9AEBB" }}
              onClick={undefined}
            />
            <RadioToggleButton
              id={"No, capturar comprobante"}
              text={"No, capturar comprobante"}
              value={"No, capturar comprobante"}
              type={"radio"}
              name={"No, capturar comprobante"}
              onChange={radioChangeHandler}
              isSelected={radioToggleValue == "No, capturar comprobante"}
              className="radioToggleButton"
              icon={undefined}
              displayImg="d-none"
              disabledInput={undefined}
              divStyle={undefined}
              labelStyle={undefined}
              onClick={undefined}
            />
          </div>
        </div>
      </div>
      <div className="footer--pin">
        <div className="wrapping-box-container">
          <div id="main-interface">
            <Button
              text={"Continuar"}
              divClassName={"d-grid gap-2"}
              buttonClassName={`${btnColor} w-100 place-content-center align-self-center`}
              spinner={activeSpinner}
              onClick={() => {
                continueProcess();
              }}
              disabled={enabledButton}
              dataBsDismiss={undefined}
            />
            <div className="text-center mt-3">
              <Link
                text={"Seguir más tarde"}
                url={null}
                styleLink={{
                  color: "#5A6172",
                  lineHeight: "16px",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={followLaterAction}
                className={""}
              />
            </div>
          </div>
        </div>
      </div>
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle={"¡Ups lo sentimos!"}
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: "Reintentar",
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => {
              functionProcessModal();
            },
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: "La aplicación no esta respondiendo debido a que hay problemas con la comunicación de nuestros sistemas.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: "Vuelve a intentar si el error persiste.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default AddressCondition;